import React from 'react';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { UserIcon } from '@cp/ds/src/icons/user';
import { LikeIcon } from '@cp/ds/src/icons/like';

export const useAppMenuItems = () => {
  const resolver = useClientWebResolver();

  return React.useMemo(
    () => ({
      mainMenuItems: [
        {
          title: 'Пользователям',
          id: 'for-users',
          icon: UserIcon,
          items: [
            {
              label: 'Оплата',
              link: resolver.resolve({ page: ClientWebPage.PaymentAndRefund }),
            },
            {
              label: 'Карта сайта',
              link: `${resolver.resolve({ page: ClientWebPage.Sitemap })}`,
            },
            {
              label: 'Вопросы и ответы',
              link: resolver.resolve({ page: ClientWebPage.FAQ }),
            },
            {
              label: 'Отзывы',
              link: resolver.resolve({ page: ClientWebPage.Feedbacks }),
            },
            {
              label: 'Статьи и советы',
              link: '/blog/',
              external: true,
            },
            {
              label: 'Правовая информация',
              link: resolver.resolve({ page: ClientWebPage.LegalInformation }),
            },
          ],
        },
        {
          title: 'О компании',
          id: 'about-company',
          icon: LikeIcon,
          items: [
            {
              label: 'О нас',
              link: resolver.resolve({ page: ClientWebPage.AboutUs }),
            },
            {
              label: 'СМИ о нас',
              link: `${resolver.resolve({ page: ClientWebPage.AboutUs })}#media`,
            },
            {
              label: 'Партнеры',
              link: `${resolver.resolve({ page: ClientWebPage.AboutUs })}#partners`,
            },
            {
              label: 'Команда',
              link: `${resolver.resolve({ page: ClientWebPage.Team })}`,
            },
            {
              label: 'Сертификаты и лицензии',
              link: `${resolver.resolve({ page: ClientWebPage.AboutUs })}#trademark`,
            },
            {
              label: 'Контакты',
              link: resolver.resolve({ page: ClientWebPage.Contacts }),
            },
          ],
        },
      ],
    }),
    [resolver],
  );
};
